/** Shared visual tokens for the redesigned teacher module (playful, high-contrast). */

export const TEACHER_PAGE_BG = {
	minHeight: "100vh",
	background: `
		linear-gradient(180deg, #b8e8ff 0%, #e8f7ff 28%, #c8f0d8 72%, #7ec96f 100%)
	`,
	backgroundAttachment: "fixed",
};

export const GRADE_BUTTON_PALETTE = [
	{ bg: "#f97316", shadow: "#c2410c" },
	{ bg: "#3b82f6", shadow: "#1d4ed8" },
	{ bg: "#a855f7", shadow: "#6b21a8" },
	{ bg: "#14b8a6", shadow: "#0f766e" },
	{ bg: "#eab308", shadow: "#a16207" },
	{ bg: "#ef4444", shadow: "#b91c1c" },
];

export const TOPIC_TILE_PALETTE = [
	{ bg: "#f97316", shadow: "#c2410c" },
	{ bg: "#14b8a6", shadow: "#0f766e" },
	{ bg: "#a855f7", shadow: "#6b21a8" },
	{ bg: "#22c55e", shadow: "#15803d" },
	{ bg: "#eab308", shadow: "#a16207" },
	{ bg: "#3b82f6", shadow: "#1d4ed8" },
];

export const CARD_SURFACE = {
	borderRadius: 3,
	backgroundColor: "rgba(255,255,255,0.95)",
	boxShadow: "0 8px 32px rgba(15, 23, 42, 0.12)",
	border: "1px solid rgba(255,255,255,0.8)",
};
